import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import store from "@/state/store";
import routes from "./routes";
import VueCookies from "vue-cookies";
import { AuthService } from "@/services/auth.service";
import { getListPermissionsUser, checkPackage} from './middlewares'

Vue.use(VueRouter);
Vue.use(VueMeta, {
  keyName: "page"
});

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
router.beforeEach(async (routeTo, routeFrom, next) => {
  if(!store.getters["auth/loggedIn"] && VueCookies.isKey('TID') && VueCookies.isKey('UID') && VueCookies.isKey('MID') && VueCookies.isKey('ACTIVE')) {
    try {
      AuthService.fetchToken(VueCookies.get('TID'))
      const request = {
        channel: "WEB",
        userId: VueCookies.get('UID'),
        merchantId: VueCookies.get('MID')
      };
      await AuthService.getUser(request)
      // eslint-disable-next-line no-empty
    }catch {}
  }
  const authRequired = routeTo.matched.some(route => route.meta.authRequired);
  if (!authRequired) return next();

  if (store.getters["auth/loggedIn"]) {
    return next();
  }
  redirectToLogin();

  function redirectToLogin() {
    next({ name: "login" });
  }
});
router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }
  next();
});

router.beforeEach(getListPermissionsUser)
router.beforeEach(checkPackage)

export default router;
